import img1 from 'images/getty-images-desktop.jpg'
import img2 from 'images/jack-anstey-desktop.jpg'
import img3 from 'images/ricardo-gomez-desktop.jpg'
import img4 from 'images/nicolas-j-desktop.jpg'

export const DesktopImages = () => {
  return [img1, img2, img3, img4]
}
